<template>
    <div
        class="option relative"
        :class="{ 'is-active': localSelected === option.value }"
        @click.prevent="localSelected = option.value"
    >
        <label class="radio">
            <input
                v-model="localSelected"
                type="radio"
                :value="option.value"
                :name="option.name"
            >

            <div class="icon">
                <font-awesome-icon icon="circle" class="text-xs" />
            </div>

            <span class="option-label">
                {{ option.placeholder }}

                <span v-if="option.price_label" class="font-regular ml-auto md:ml-0">
                    {{ option.price_label }}
                </span>
            </span>
            <div v-if="option.more_info_text" class="ml-xl">
                <button
                    type="button"
                    @click.stop="$modal.show(modalName)"
                >
                    <font-awesome-icon icon="info-circle" class="text-sm" />
                </button>
                <standard-modal
                    :name="modalName"
                    :title="option.placeholder"
                    :show-close-button="true"
                >
                    <!-- eslint-disable vue/no-v-html -->
                    <span v-html="option.more_info_text" />
                </standard-modal>
            </div>
        </label>
    </div>
</template>

<script>
    export default {
        model: {
            prop: 'selected',
            event: 'input',
        },
        props: {
            additionalClass: {
                required: false,
                type: String,
                default: '',
            },
            option: {
                required: true,
                type: Object,
            },
            selected: {
                type: [String, Number],
                required: false,
                default: null,
            },
        },
        computed: {
            localSelected: {
                get() {
                    return this.selected;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                },
            },
            modalName() {
                return `option-box-radio-modal-${this.option.value}`;
            },
        },
    };
</script>
